"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EcoaQuestionnaire = exports.EcoaQuestionnaireData = exports.EcoaVisit = exports.EcoaVisitStatus = void 0;
var EcoaVisitStatus;
(function (EcoaVisitStatus) {
    EcoaVisitStatus["NotAvailable"] = "NOT_AVAILABLE";
    EcoaVisitStatus["NotDone"] = "NOT_DONE";
    EcoaVisitStatus["Ongoing"] = "ONGOING";
    EcoaVisitStatus["Done"] = "DONE";
})(EcoaVisitStatus = exports.EcoaVisitStatus || (exports.EcoaVisitStatus = {}));
class EcoaVisit {
}
exports.EcoaVisit = EcoaVisit;
class EcoaQuestionnaireData {
}
exports.EcoaQuestionnaireData = EcoaQuestionnaireData;
class EcoaQuestionnaire {
}
exports.EcoaQuestionnaire = EcoaQuestionnaire;
//# sourceMappingURL=ecoaVisit.js.map